<template>
  <div>
    <ValidationProvider :rules="{ required: true, max: 100 }" name="solicitado por" v-slot="{ errors }">
      <b-form-group class="mb-2">
        <template #label>
          <span>Seleccionar contacto</span>
          <span v-if="!clientId" class="text-info fs-12 ml-2">
            <span class="asterisk">*</span>
            <font-awesome-icon :icon="['far', 'info-circle']" size="sm" />
            Debe seleccionar un cliente primero
          </span>
        </template>
        <b-select
          v-model="selectedContactId"
          :options="contactOptions"
          :state="(errors[0] || !contactForm.client_contact_id) ? false : null"
          @change="onContactSelect"
        >
          <template #first>
            <option :value="null">-- Seleccionar --</option>
          </template>
        </b-select>
      </b-form-group>
    </ValidationProvider>

    <b-row>
      <b-col md="12">
        <ValidationProvider :rules="{ required: true, max: 100 }" name="solicitado por" v-slot="{ errors }">
          <b-form-group class="mb-2">
            <template #label>
              <span>Solicitado por</span><span class="asterisk">*</span>
            </template>
            <b-input
              v-model="contactForm.solicited_by"
              type="text"
              placeholder="Persona que solicita"
              :state="(errors[0] || !contactForm.client_contact_id) ? false : null"
              disabled
            />
          </b-form-group>
        </ValidationProvider>
      </b-col>

      <b-col md="6">
        <ValidationProvider :rules="{ required: true, max: 20 }" name="teléfono" v-slot="{ errors }">
          <b-form-group class="mb-2">
            <template #label>
              <span>Teléfono</span><span class="asterisk">*</span>
            </template>
            <b-input
              v-model="contactForm.telephone"
              type="text"
              placeholder="8888-8888"
              :state="errors[0] ? false : null"
            />
          </b-form-group>
        </ValidationProvider>
      </b-col>

      <b-col md="6">
        <ValidationProvider :rules="{ required: false, email: true }" name="correo" v-slot="{ errors }">
          <b-form-group class="mb-0">
            <template #label><span>Correo electrónico</span></template>
            <b-input
              v-model="contactForm.contact_email"
              type="text"
              placeholder="correo@empresa.com"
              :state="errors[0] ? false : null"
            />
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'ContactForm',
  components: { ValidationProvider },
  props: {
    contactForm: { type: Object, required: true },
    contacts:    { type: Array,  default: () => [] },
    clientId:    { type: [Number, String], default: null },
  },
  data() {
    return {
      selectedContactId: null,
    }
  },
  mounted () {
    this.selectedContactId = this.contactForm.client_contact_id
  },
  computed: {
    contactOptions() {
      return this.contacts.map(c => ({ text: c.name, value: c.id }))
    },
  },
  watch: {
    clientId(newVal, oldVal) {
      if (newVal != oldVal) this.reset()
    }
  },
  methods: {
    onContactSelect (id) {
      const c = this.contacts.find(x => x.id === id) || {}
      this.contactForm.client_contact_id = c.id    || null
      this.contactForm.solicited_by      = c.name  || ''
      this.contactForm.telephone         = c.phone || ''
      this.contactForm.contact_email     = c.email || ''
    },

    reset () {
      this.selectedContactId             = null
      this.contactForm.client_contact_id = null
      this.contactForm.solicited_by      = ''
      this.contactForm.telephone         = ''
      this.contactForm.contact_email     = ''
    },
  },
}
</script>

<style scoped>
  .asterisk { color: #dc2626; margin-left: 2px; }
</style>
